import React, { SVGProps } from 'react'

export const FirstActiveLeftSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="36"
    viewBox="0 0 16 36"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M.502 14.966C-2.668 30.111 9.979 36 16 36V1C7.227 2.496 2.313 6.315.502 14.966Z"
    />
  </svg>
)
